import OnlineMeetingNotification from './OnlineMeetingNotification'

export default OnlineMeetingNotification
